import { baseQuery } from '../baseQuery';
import { AvailabilityStatus } from 'types';

type PutTechnicianAvailabilityCalendarPayload = {
  technicianId: number;
  slots: string[];
  status: AvailabilityStatus;
};

export const putTechnicianAvailabilityCalendar = async (payload: PutTechnicianAvailabilityCalendarPayload) => {
  const { technicianId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/availability-calendar`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data;
};
